<template>
  <ul class="navbar-nav ml-auto">
    <li class="nav-item">
      <div @click="logout" class="nav-link clickable">
        <p>Log Out</p>
      </div>
    </li>
  </ul>
</template>

<script>
import auth from '../../services/auth';

export default {
  name: "LogoutButton",
  methods: {
    logout() {
      auth.logout();
      this.$router.push('/login');
      this.$router.go();
    }
  }
};
</script>
